const a = (o) => ({
  boxShadow: "0px 20px 24px -4px #10182814",
  peers: {
    Dialog: {
      border: "1px solid var(--gray-100)",
      borderRadius: "8px",
      closeIconSize: o.showHeader && o.showClose ? "12px" : "0",
      closeMargin: "16px 16px 0 0",
      closeSize: o.showHeader && o.showClose ? "20px" : "0",
      closeIconColor: "var(--gray-500)",
      color: "#FFF",
      contentMargin: o.showHeader ? "16px 0 0 0" : "0",
      iconMargin: "0 8px 0 0",
      iconSize: "32px",
      padding: "0",
      titleTextColor: "var(--gray-900)"
    }
  }
}), i = (o) => {
  let e = {
    backIconStroke: "var(--gray-600)",
    contentPadding: "0 16px 16px",
    contentTextColor: "var(--gray-500)",
    dialogIconSize: "18px",
    dialogIconWrapperSize: "32px",
    headerIconDisplay: o.showHeader && o.showHeaderIcon ? "inline-flex" : "none",
    headerPadding: "16px 16px 0 16px",
    headerPaddingRight: o.showClose ? "calc(var(--n-close-size) + 22px)" : "16px",
    maxModalHeight: "calc(100vh - 24px)",
    maxModalWidth: "calc(100vw - 24px)",
    width: o.width ? `${o.width}px` : "483px"
  };
  const r = {
    default: {
      dialogIconBgColor: "var(--gray-100)",
      dialogIconStroke: "var(--gray-600)"
    },
    info: {
      dialogIconBgColor: "var(--primary-100)",
      dialogIconStroke: "var(--primary-700)"
    },
    success: {
      dialogIconBgColor: "var(--success-100)",
      dialogIconStroke: "var(--success-700)"
    },
    warning: {
      dialogIconBgColor: "var(--warning-100)",
      dialogIconStroke: "var(--warning-600)"
    },
    error: {
      dialogIconBgColor: "var(--error-100)",
      dialogIconStroke: "var(--error-700)"
    }
  };
  return o.type && (e = { ...e, ...r[o.type] }), e;
};
export {
  i as modalStyleOverrides,
  a as modalThemeOverrides
};
